import { actionTypes } from './actions';

export const initialState = {
  colorSet: null,
};

export default function changeThemeReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CHANGE_THEME: {
      const { colorSet } = action;

      return {
        ...state,
        colorSet,
      };
    }

    default:
      return state;
  }
}
